// extracted by mini-css-extract-plugin
module.exports = {"NavList":"NavList___1vtSm","NavItem":"NavItem___aXzmi","active":"active___3GzsU","newButton":"newButton___1PzaF"};